import { render, staticRenderFns } from "./password-remind.vue?vue&type=template&id=d386c1d8"
import script from "./password-remind.vue?vue&type=script&lang=js"
export * from "./password-remind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports